import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SalesTransportCapacityComponent } from './sales-transport-capacity.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';


const routes: Routes = [
    {
        path: '',
        component: SalesTransportCapacityComponent,
        canDeactivate:[DeactivateGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SalesTransportCapacityRoutingModule { }
